import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { runtimeLogger } from '../../utils/runtime-logger.util';
import { MatDialog } from '@angular/material/dialog'; // ADICIONADO
import { InfoField } from '../shared/info-field/info-field';
import { LeadsUpdateStatusModal } from '../shared/leads-update-status-modal/leads-update-status-modal'; // ADICIONADO - ajuste o caminho conforme necessário

@Component({
  selector: 'app-offer-info',
  imports: [CommonModule, FormsModule, InfoField],
  templateUrl: './offer-info.html',
  styleUrl: './offer-info.scss'
})
export class OfferInfo {
  @Input() carTitle: string = '';
  @Input() carImage: string = '';
  @Input() carInfos: any[] = [];
  @Input() selectedOffer: any = null;
  @Input() leadId: string = ''; // ADICIONADO para passar o ID do lead

  // Texto que será exibido (vindo do componente pai)
  @Input() currentOfferText: string = '';

  // Estado de loading
  @Input() isLoadingText: boolean = false;

  // Eventos que serão emitidos para o componente pai
  @Output() sendAmigavel = new EventEmitter<void>();
  @Output() sendFormal = new EventEmitter<void>();
  @Output() sendPersuasiva = new EventEmitter<void>();
  @Output() sendServicosFinanceiros = new EventEmitter<void>();
  @Output() sendOfferEmail = new EventEmitter<{email: string, text: string}>();
  @Output() sendOfferWhatsapp = new EventEmitter<{phone: string, text: string}>();

  constructor(
    private snack: MatSnackBar,
    private dialog: MatDialog // ADICIONADO
  ) {}

  selectedOption: string = 'friendly';

  options = [
    { id: 'friendly', label: 'Amigável' },
    { id: 'formal', label: 'Formal' },
    { id: 'persuasive', label: 'Persuasiva' },
    { id: 'servicosfinanceiros', label: 'Serviços Financeiros' },
  ];

  get hasCarImage(): boolean {
    return Boolean(this.carImage?.trim());
  }

  get infoFieldData(): any[] {
    return this.carInfos.map(info => ({
      type: 'text' as const,
      title: info.title,
      info: info.value
    }));
  }

  selectOption(optionId: string) {
    this.selectedOption = optionId;

    // Emitir evento com base na opção selecionada
    switch(optionId) {
      case 'friendly':
        this.sendAmigavel.emit();
        break;
      case 'formal':
        this.sendFormal.emit();
        break;
      case 'persuasive':
        this.sendPersuasiva.emit();
        break;
      case 'servicosfinanceiros':
        this.sendServicosFinanceiros.emit();
        break;
    }
  }

  sendEmail() {
    this.sendOfferEmail.emit({
      email: this.selectedOffer.contactMail,
      text: this.currentOfferText
    });
  }

  sendWhatsApp() {
    this.sendOfferWhatsapp.emit({
      phone: this.selectedOffer.contactCelphone,
      text: this.currentOfferText
    });
  }

  copyToClipboard() {
    if (!this.currentOfferText) return;

    navigator.clipboard.writeText(this.currentOfferText)
      .then(() => {
        this.snack.open('Texto copiado para a área de transferência!', 'Fechar', {
          duration: 3000,
          panelClass: 'success-snackbar'
        });
      })
      .catch(err => {
        console.error('Erro ao copiar texto: ', err);
        this.fallbackCopyTextToClipboard(this.currentOfferText);
      });
  }

  private fallbackCopyTextToClipboard(text: string) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.snack.open('Texto copiado para a área de transferência!', 'Fechar', {
          duration: 3000,
          panelClass: 'success-snackbar'
        });
      } else {
        this.snack.open('Não foi possível copiar o texto', 'Fechar', {
          duration: 3000,
          panelClass: 'error-snackbar'
        });
      }
    } catch (err) {
      console.error('Erro ao copiar texto: ', err);
      this.snack.open('Erro ao copiar texto', 'Fechar', {
        duration: 3000,
        panelClass: 'error-snackbar'
      });
    }

    document.body.removeChild(textArea);
  }

  // MÉTODO PARA ABRIR MODAL DE ALTERAR STATUS
  openChangeStatusModal(): void {
    // Usa o leadId do selectedOffer ou do input leadId
    const idLead = this.selectedOffer?.idLead || this.leadId;
    runtimeLogger.debug(idLead);

    if (!idLead) {
      console.error('Lead ID não encontrado para abrir modal de status');
      this.snack.open('Não foi possível identificar o lead', 'Fechar', {
        duration: 3000,
        panelClass: 'error-snackbar'
      });
      return;
    }

    this.dialog.open(LeadsUpdateStatusModal, {
      width: 'auto',
      maxWidth: '95vw',
      panelClass: 'dialog-alterar-status',
      data: { idLead: idLead }
    });
  }
}
